import { EpDevPError } from "./EpDevPError";

/**
 * Careful when throwing this error.
 * The plugin will be registered as unavailable and all subsequent API calls will fail.
 */
export class EpDevPInternalServerError extends EpDevPError {
  private static Name = "EpDevPInternalServerError";
  private static DefaultDescription = 'Internal Server Error';
  public details: any;
  constructor(internalLogName: string, message: string, details: any) {
    super(internalLogName, EpDevPInternalServerError.DefaultDescription);
    this.name = EpDevPInternalServerError.Name;
    this.details = {
      message: message,
      ...details
    };
  }
}

export class EpDevPServiceError extends EpDevPError {
  private static Name = "EpDevPServiceError";
  private static DefaultDescription = 'Internal Service Error';
  public cause?: Error;
  constructor(internalLogName: string, cause?: Error) {
    super(internalLogName, EpDevPServiceError.DefaultDescription);
    this.name = EpDevPServiceError.Name;
    this.cause = cause;
  }
}

export class EpDevPServiceConnectionError extends EpDevPError {
  private static Name = "EpDevPServiceConnectionError";
  private static DefaultDescription = 'Internal Service Connection Error';
  public cause?: Error;
  constructor(internalLogName: string, cause?: Error) {
    super(internalLogName, EpDevPServiceConnectionError.DefaultDescription);
    this.name = EpDevPServiceConnectionError.Name;
    this.cause = cause;
  }
}

type TEpDevPUnknownBrokerTypeErrorDetails = {
  brokerType: string;
  options: Array<string>;
}
export class EpDevPUnknownBrokerTypeError extends EpDevPError {
  private static DefaultDescription = 'Unknown Broker Type Error';
  public details: TEpDevPUnknownBrokerTypeErrorDetails;
  constructor(internalLogName: string, details: TEpDevPUnknownBrokerTypeErrorDetails) {
    super(internalLogName, EpDevPUnknownBrokerTypeError.DefaultDescription);
    this.details = details;
  }
}

type TEpDevPEpApiContentErrorDetails = {
  issue: string;
  data: any;
}
export class EpDevPEpApiContentError extends EpDevPError {
  private static DefaultDescription = 'Event Portal API Error';
  public details: TEpDevPEpApiContentErrorDetails;
  constructor(internalLogName: string, details: TEpDevPEpApiContentErrorDetails) {
    super(internalLogName, EpDevPEpApiContentError.DefaultDescription);
    this.details = details;
  }
}
export class EpDevPEpApimApiContentError extends EpDevPError {
  private static DefaultDescription = 'Event Portal APIM API Error';
  public details: TEpDevPEpApiContentErrorDetails;
  constructor(internalLogName: string, details: TEpDevPEpApiContentErrorDetails) {
    super(internalLogName, EpDevPEpApimApiContentError.DefaultDescription);
    this.details = details;
  }
}

type TEpDevPEpSendMailErrorDetails = {
  info: any;
}
export class EpDevPEpSendMailError extends EpDevPError {
  private static DefaultDescription = 'Send Mail Error';
  public details: TEpDevPEpSendMailErrorDetails;
  constructor(internalLogName: string, details: TEpDevPEpSendMailErrorDetails) {
    super(internalLogName, EpDevPEpSendMailError.DefaultDescription);
    this.details = details;
  }
}

